<template>
  <div class="container">
    <div class="row width_full">
      <div class="col_12">
        <div class="common_title">
          <h2>{{ pageTitle }}</h2>
        </div>
        <div class="row">
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('name')}]">
              <label>Name</label>
              <input type="text" class="form_global" placeholder="Title Korean" v-model="form.name">
              <template v-if="errors && errors.name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('user_name')}]">
              <label>Username</label>
              <input type="text" :disabled="true" class="form_global" placeholder="Title English" v-model="form.user_name">
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('email')}]">
              <label>Email</label>
              <input type="text" :disabled="true" class="form_global" placeholder="Title English" v-model="form.email">
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('address')}]">
              <label>Address</label>
              <input type="text" class="form_global" placeholder="Title Korean" v-model="form.address">
              <template v-if="errors && errors.address">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.address" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('contact')}]">
              <label>Contact</label>
              <input type="text" class="form_global" placeholder="Title Korean" v-model="form.contact">
              <template v-if="errors && errors.contact">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.contact" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('address')}]">
              <label>Cell Phone</label>
              <input type="text" class="form_global" placeholder="Title Korean" v-model="form.cell_phone">
              <template v-if="errors && errors.cell_phone">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.cell_phone" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('zip_code')}]">
              <label>ZIP Code</label>
              <input type="text" class="form_global" placeholder="Title Korean" v-model="form.zip_code">
              <template v-if="errors && errors.zip_code">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.zip_code" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group']">
              <label>Type</label>
              <select  class="form_global" v-model="form.type">
                <option value="정회원">정회원</option>
                <option value="준회원">준회원</option>
                <option value="새싹회원">새싹회원</option>
              </select>
            </div>
          </div>

        </div>


        <div class="d_flex_end">
          <button class="btn btn_common" @click="submitForm()">Save</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Form",
  data(){
    return{
      user: null,
      form:{
        address: '',
        area: '',
        calendar: '',
        cell_phone: '',
        contact: '',
        dob: '',
        email: '',
        mail_service: '',
        name: '',
        type: '',
        user_name: '',
        user_type: '',
        zip_code: '',
      }
    }
  },
  created() {
    this.axios.get('customers/'+this.$route.params.id).then((response) => {
      this.form = response.data.data
    })
  },
  methods:{
    submitForm(){
      this.errors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      })

      formData.append('_method','PATCH')

      this.axios.post('/customers/'+this.$route.params.id, formData)
          .then(() => {
            this.$router.push({name: 'customers'})
            this.showSuccessMsg('Customer Updated!')
          })
          .catch((err) => {
            this.errors = err.response.data.errors
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>